import {REQUEST_MY_PRODUCTS, RECEIVE_MY_PRODUCTS} from '../constants/actionTypes';
import objectAssign from 'object-assign';
import initialState from './initialState';

// IMPORTANT: Note that with Redux, state should NEVER be changed.
// State is considered immutable. Instead,
// create a copy of the state passed and set new values on the copy.
// Note that I'm using Object.assign to create a copy of current state
// and update values on the copy.
export default function productsReducer(state = initialState, action) {
  switch (action.type) {
    case REQUEST_MY_PRODUCTS:
      return objectAssign({}, state, {
        isFetching: true
      });

    case RECEIVE_MY_PRODUCTS:
      return objectAssign({}, state, {
        myProducts: action.products,
        isFetching: false
      });

    default:
      return state;
  }
}
